import { FC } from "react";
import { useTranslation } from "react-i18next";

import { LandingLayout, LoaderMuiLanding } from "@ryde/controls-landing";
import {
  CompanyScopeLandingsContextWrapper,
  ILandingPage,
  LandingCompanyIdEnum,
  useLandingInit,
} from "@ryde/utils-landings";

import { HerzliyaWrapper } from "./herzliya-wrapper.styled";

export const HerzliyaPage: FC<ILandingPage> = ({ companyId }) => {
  const { t } = useTranslation();
  const { landingInitData, isLoading } = useLandingInit({ companyId });
  return (
    <>
      {landingInitData && (
        <CompanyScopeLandingsContextWrapper
          companyId={landingInitData.companyId}
        >
          <HerzliyaWrapper>
            <LandingLayout stepsContainerId={LandingCompanyIdEnum.Herzliya} />
          </HerzliyaWrapper>
        </CompanyScopeLandingsContextWrapper>
      )}
      {isLoading && <LoaderMuiLanding loading text={t("ui.LOADING_DATA")} />}
    </>
  );
};
